import { isIosDevice } from '../parent/installHelp';

/**
 * After signing in on an iPhone or iPad, load the app fresh instead of switching screens in place (#427).
 * Typing the sign-in leaves the iOS keyboard's viewport offset behind once it closes, so fixed parts of the
 * page (the bottom menu bar) are placed against the wrong spot and scroll away until the app is reopened.
 * A real page load clears it, just as reopening does. Returns true when it reloaded, so the caller stops.
 */
export function freshStartOnIos(path: string): boolean {
  if (!isIosDevice()) return false;
  (document.activeElement as HTMLElement | null)?.blur();
  window.location.replace(path);
  return true;
}
